<template>
    <!-- ========================================== -->
    <!-- BANNER DE COOKIES (Primera capa)          -->
    <!-- ========================================== -->
    <div v-if="!cookiesAceptadas" class="cookie-consent">
        <div class="cookie-content">
            <div class="cookie-text">
                <p>
                    {{ $t('cookies.new_banner_text') }}
                    <a href="#" @click.prevent="abrirPoliticaCompleta" class="cookie-link">
                        {{ $t('cookies.policy_link') }}
                    </a>
                    {{ $t('cookies.new_banner_text_end') }}
                </p>
            </div>
            <div class="cookie-actions">
                <button class="cookie-btn cookie-btn-primary" @click="rechazarCookies">
                    {{ $t('cookies.reject') }}
                </button>
                <button class="cookie-btn cookie-btn-primary" @click="aceptarCookies">
                    {{ $t('cookies.accept_all') }}
                </button>
                <button class="cookie-btn cookie-btn-primary" @click="configurarCookies">
                    {{ $t('cookies.configure') }}
                </button>
            </div>
        </div>
    </div>

    <!-- ========================================== -->
    <!-- MODAL DE CONFIGURACIÓN (Segunda capa)     -->
    <!-- ========================================== -->
    <div v-if="mostrarConfiguracion" class="cookie-modal">
        <div class="cookie-modal-content">
            <h2>{{ $t('cookies.policy_title') }}</h2>
            
            <!-- DEFINICIÓN Y FUNCIÓN GENÉRICA -->
            <section class="cookie-section">
                <h3>{{ $t('cookies.definition_title') }}</h3>
                <p>{{ $t('cookies.definition_text') }}</p>
                <p>{{ $t('cookies.definition_text2') }}</p>
                <p>{{ $t('cookies.definition_text3') }}</p>
                <p>{{ $t('cookies.definition_text4') }}</p>
            </section>

            <!-- COOKIES UTILIZADAS -->
            <section class="cookie-section">
                <h3>{{ $t('cookies.cookies_used_title') }}</h3>
                
                <!-- Cookies necesarias -->
                <div class="cookie-option">
                    <div class="cookie-option-header">
                        <label class="cookie-label">
                            <input type="checkbox" checked disabled>
                            <strong>{{ $t('cookies.necessary') }}</strong>
                        </label>
                        <span class="cookie-badge">{{ $t('cookies.always_active') }}</span>
                    </div>
                    <p>{{ $t('cookies.necessary_text_new') }}</p>
                    <div class="cookie-table-wrapper">
                        <table class="cookie-table">
                            <thead>
                                <tr>
                                    <th>{{ $t('cookies.table.name') }}</th>
                                    <th>{{ $t('cookies.table.provider') }}</th>
                                    <th>{{ $t('cookies.table.purpose') }}</th>
                                    <th>{{ $t('cookies.table.expiry') }}</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr>
                                    <td>cookie-agreed</td>
                                    <td>{{ $t('cookies.provider_internal') }}</td>
                                    <td>{{ $t('cookies.necessary_purpose') }}</td>
                                    <td>{{ $t('cookies.duration_1year') }}</td>
                                </tr>
                                <tr>
                                    <td>PHPSESSID</td>
                                    <td>{{ $t('cookies.provider_internal') }}</td>
                                    <td>{{ $t('cookies.session_purpose') }}</td>
                                    <td>{{ $t('cookies.duration_session') }}</td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>

                <!-- Cookies de preferencias -->
                <div class="cookie-option">
                    <div class="cookie-option-header">
                        <label class="cookie-label">
                            <input type="checkbox" v-model="preferencias.preferencias">
                            <strong>{{ $t('cookies.preferences') }}</strong>
                        </label>
                    </div>
                    <p>{{ $t('cookies.preferences_text_new') }}</p>
                    <div class="cookie-table-wrapper">
                        <table class="cookie-table">
                            <thead>
                                <tr>
                                    <th>{{ $t('cookies.table.name') }}</th>
                                    <th>{{ $t('cookies.table.provider') }}</th>
                                    <th>{{ $t('cookies.table.purpose') }}</th>
                                    <th>{{ $t('cookies.table.expiry') }}</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr>
                                    <td>PHPSESSID</td>
                                    <td>{{ $t('cookies.provider_internal') }}</td>
                                    <td>{{ $t('cookies.preferences_purpose') }}</td>
                                    <td>{{ $t('cookies.duration_session') }}</td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>

                <!-- Cookies de estadísticas -->
                <div class="cookie-option">
                    <div class="cookie-option-header">
                        <label class="cookie-label">
                            <input type="checkbox" v-model="preferencias.estadisticas">
                            <strong>{{ $t('cookies.statistics') }}</strong>
                        </label>
                    </div>
                    <p>{{ $t('cookies.statistics_text_new') }}</p>
                    <p class="cookie-opt-out">
                        {{ $t('cookies.ga_optout_text') }}
                        <a href="https://tools.google.com/dlpage/gaoptout?hl=es" target="_blank">
                            {{ $t('cookies.ga_optout_link') }}
                        </a>
                    </p>
                    <div class="cookie-table-wrapper">
                        <table class="cookie-table">
                            <thead>
                                <tr>
                                    <th>{{ $t('cookies.table.name') }}</th>
                                    <th>{{ $t('cookies.table.provider') }}</th>
                                    <th>{{ $t('cookies.table.purpose') }}</th>
                                    <th>{{ $t('cookies.table.expiry') }}</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr>
                                    <td>_ga</td>
                                    <td>Google Analytics</td>
                                    <td>{{ $t('cookies.ga_purpose') }}</td>
                                    <td>{{ $t('cookies.duration_2years') }}</td>
                                </tr>
                                <tr>
                                    <td>_gid</td>
                                    <td>Google Analytics</td>
                                    <td>{{ $t('cookies.gid_purpose') }}</td>
                                    <td>{{ $t('cookies.duration_24hours') }}</td>
                                </tr>
                                <tr>
                                    <td>_gat</td>
                                    <td>Google Analytics</td>
                                    <td>{{ $t('cookies.gat_purpose') }}</td>
                                    <td>{{ $t('cookies.duration_1minute') }}</td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>

                <!-- Cookies de Marketing -->
                <div class="cookie-option">
                    <div class="cookie-option-header">
                        <label class="cookie-label">
                            <input type="checkbox" v-model="preferencias.marketing">
                            <strong>{{ $t('cookies.marketing') }}</strong>
                        </label>
                    </div>
                    <p>{{ $t('cookies.marketing_text_new') }}</p>
                    <div class="cookie-table-wrapper">
                        <table class="cookie-table">
                            <thead>
                                <tr>
                                    <th>{{ $t('cookies.table.name') }}</th>
                                    <th>{{ $t('cookies.table.provider') }}</th>
                                    <th>{{ $t('cookies.table.purpose') }}</th>
                                    <th>{{ $t('cookies.table.expiry') }}</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr>
                                    <td>fbp</td>
                                    <td>Facebook (Meta)</td>
                                    <td>{{ $t('cookies.fbp_purpose') }}</td>
                                    <td>{{ $t('cookies.duration_3months') }}</td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </section>

            <!-- CÓMO HABILITAR/DESHABILITAR COOKIES -->
            <section class="cookie-section">
                <h3>{{ $t('cookies.how_to_title') }}</h3>
                <p>{{ $t('cookies.how_to_text') }}</p>
                <ul class="browser-list">
                    <li>
                        <strong>Internet Explorer:</strong> 
                        {{ $t('cookies.ie_instructions') }}
                        <a href="http://windows.microsoft.com/es-ES/windows/support" target="_blank">{{ $t('cookies.ie_link') }}</a>
                    </li>
                    <li>
                        <strong>Firefox:</strong> 
                        {{ $t('cookies.firefox_instructions') }}
                        <a href="http://support.mozilla.org/es/home" target="_blank">{{ $t('cookies.firefox_link') }}</a>
                    </li>
                    <li>
                        <strong>Chrome:</strong> 
                        {{ $t('cookies.chrome_instructions') }}
                        <a href="http://support.google.com/chrome/?hl=es" target="_blank">{{ $t('cookies.chrome_link') }}</a>
                    </li>
                    <li>
                        <strong>Safari:</strong> 
                        {{ $t('cookies.safari_instructions') }}
                        <a href="http://www.apple.com/es/support/safari/" target="_blank">{{ $t('cookies.safari_link') }}</a>
                    </li>
                </ul>
                <div class="cookie-warning">
                    <strong>{{ $t('cookies.what_happens_title') }}</strong>
                    <p>{{ $t('cookies.what_happens_text') }}</p>
                </div>
            </section>

            <div class="cookie-modal-actions">
                <button class="cookie-btn cookie-btn-primary" @click="rechazarCookies">
                    {{ $t('cookies.reject') }}
                </button>
                <button class="cookie-btn cookie-btn-primary" @click="aceptarCookies">
                    {{ $t('cookies.accept_all') }}
                </button>
                <button class="cookie-btn cookie-btn-primary" @click="guardarPreferencias">
                    {{ $t('cookies.save_preferences') }}
                </button>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'CookieConsent',
    data() {
        return {
            cookiesAceptadas: false,
            mostrarConfiguracion: false,
            preferencias: {
                necesarias: true,
                preferencias: false,
                estadisticas: false,
                marketing: false
            }
        }
    },
    computed: {
        currentLang() {
            return this.$route.params.lang || 'es'
        }
    },
    mounted() {
        const consent = localStorage.getItem('cookie_consent')
        if (consent) {
            try {
                const parsed = JSON.parse(consent)
                // Verificar que el consentimiento no sea muy antiguo (opcional)
                // Si es muy antiguo, mostrar el banner de nuevo
                this.preferencias = parsed
                this.cookiesAceptadas = true
                this.aplicarCookies()
            } catch (e) {
                this.cookiesAceptadas = false
            }
        }
    },
    methods: {
        aceptarCookies() {
            this.preferencias = {
                necesarias: true,
                preferencias: true,
                estadisticas: true,
                marketing: true
            }
            this.guardarConsentimiento()
        },
        rechazarCookies() {
            this.preferencias = {
                necesarias: true,
                preferencias: false,
                estadisticas: false,
                marketing: false
            }
            this.guardarConsentimiento()
            this.mostrarConfiguracion = false
        },
        configurarCookies() {
            this.mostrarConfiguracion = true
        },
        guardarPreferencias() {
            this.guardarConsentimiento()
            this.mostrarConfiguracion = false
        },
        cerrarConfiguracion() {
            this.mostrarConfiguracion = false
        },
        abrirPoliticaCompleta() {
            // Desplazarse al modal o abrir la vista de política
            this.mostrarConfiguracion = true
        },
        guardarConsentimiento() {
            // 🔹 Guardar con timestamp para saber cuándo se dio el consentimiento
            const consentData = {
                ...this.preferencias,
                timestamp: new Date().toISOString()
            }
            localStorage.setItem('cookie_consent', JSON.stringify(consentData))
            this.cookiesAceptadas = true
            this.aplicarCookies()
        },
        aplicarCookies() {
            if (this.preferencias.estadisticas) {
                this.cargarGoogleAnalytics()
            }
            if (this.preferencias.marketing) {
                this.cargarFacebookPixel()
            }
        },
        cargarGoogleAnalytics() {
            // Verificar si ya está cargado
            if (document.querySelector('script[src*="googletagmanager"]')) return
            
            const script = document.createElement('script')
            script.async = true
            script.src = 'https://www.googletagmanager.com/gtag/js?id=G-9LZGY0J38Z'
            document.head.appendChild(script)
            
            const initScript = document.createElement('script')
            initScript.innerHTML = `
                window.dataLayer = window.dataLayer || [];
                function gtag(){dataLayer.push(arguments);}
                gtag('js', new Date());
                gtag('config', 'G-9LZGY0J38Z');
            `
            document.head.appendChild(initScript)
        },
        cargarFacebookPixel() {
            if (document.querySelector('script[src*="facebook.com/tr"]')) return
            
            const script = document.createElement('script')
            script.innerHTML = `
                !function(f,b,e,v,n,t,s){if(f.fbq)return;n=f.fbq=function(){n.callMethod?
                n.callMethod.apply(n,arguments):n.queue.push(arguments)};if(!f._fbq)f._fbq=n;
                n.push=n;n.loaded=!0;n.version='2.0';n.queue=[];t=b.createElement(e);t.async=!0;
                t.src=v;s=b.getElementsByTagName(e)[0];s.parentNode.insertBefore(t,s)}(window,
                document,'script','https://connect.facebook.net/en_US/fbevents.js');
                fbq('init', 'YOUR_PIXEL_ID');
                fbq('track', 'PageView');
            `
            document.head.appendChild(script)
        }
    }
}
</script>

<style scoped>
/* ========== BANNER DE COOKIES ========== */
.cookie-consent {
    position: fixed;
    bottom: 0;
    left: 0;
    right: 0;
    background: #ffffff;
    color: #333;
    padding: 20px 30px;
    z-index: 9999;
    box-shadow: 0 -4px 15px rgba(0,0,0,0.15);
    border-top: 3px solid #1C4A8D;
    animation: slideUp 0.4s ease;
}

@keyframes slideUp {
    from { transform: translateY(100%); }
    to { transform: translateY(0); }
}

.cookie-content {
    max-width: 1200px;
    margin: 0 auto;
    display: flex;
    justify-content: space-between;
    align-items: center;
    gap: 30px;
    flex-wrap: wrap;
}

.cookie-text {
    flex: 1;
    min-width: 280px;
}

.cookie-text p {
    margin: 0;
    font-size: 0.95rem;
    line-height: 1.6;
}

.cookie-link {
    color: #1C4A8D;
    font-weight: 600;
    text-decoration: underline;
}

.cookie-link:hover {
    color: #143A6E;
}

.cookie-actions {
    display: flex;
    gap: 12px;
    flex-wrap: wrap;
    align-items: center;
}

.cookie-btn {
    padding: 10px 24px;
    border-radius: 30px;
    font-weight: 600;
    cursor: pointer;
    transition: all 0.2s;
    border: none;
    font-size: 0.85rem;
}

.cookie-btn-primary {
    background: #1C4A8D;
    color: white;
}

.cookie-btn-primary:hover {
    background: #143A6E;
}

.cookie-btn-reject {
    background: transparent;
    color: #666;
    border: 1px solid #ddd;
}

.cookie-btn-reject:hover {
    background: #f5f5f5;
    border-color: #ccc;
}

.cookie-btn-config {
    background: transparent;
    color: #1C4A8D;
    border: 1px solid #1C4A8D;
}

.cookie-btn-config:hover {
    background: #e8f0fe;
}

/* ========== MODAL DE CONFIGURACIÓN ========== */
.cookie-modal {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: rgba(0,0,0,0.6);
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 10000;
    animation: fadeIn 0.3s ease;
    padding: 20px;
}

@keyframes fadeIn {
    from { opacity: 0; }
    to { opacity: 1; }
}

.cookie-modal-content {
    background: white;
    border-radius: 16px;
    padding: 40px;
    max-width: 900px;
    width: 100%;
    max-height: 90vh;
    overflow-y: auto;
}

.cookie-modal-content h2 {
    color: #1C4A8D;
    font-size: 1.8rem;
    margin-top: 0;
    margin-bottom: 10px;
    border-bottom: 2px solid #1C4A8D;
    padding-bottom: 10px;
}

.cookie-section {
    margin-bottom: 30px;
}

.cookie-section h3 {
    color: #1C4A8D;
    font-size: 1.2rem;
    margin-bottom: 12px;
}

.cookie-section p {
    font-size: 0.9rem;
    line-height: 1.6;
    color: #444;
}

.cookie-option {
    padding: 15px 20px;
    background: #f8f9fa;
    border-radius: 8px;
    border: 1px solid #e9ecef;
    margin-bottom: 15px;
}

.cookie-option-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    flex-wrap: wrap;
    gap: 8px;
    margin-bottom: 8px;
}

.cookie-label {
    display: flex;
    align-items: center;
    gap: 10px;
    cursor: pointer;
    font-size: 0.95rem;
}

.cookie-label input[type="checkbox"] {
    width: 18px;
    height: 18px;
    accent-color: #1C4A8D;
    cursor: pointer;
}

.cookie-badge {
    font-size: 0.7rem;
    background: #1C4A8D;
    color: white;
    padding: 3px 12px;
    border-radius: 12px;
    font-weight: 600;
}

.cookie-table-wrapper {
    margin-top: 10px;
    overflow-x: auto;
}

.cookie-table {
    width: 100%;
    border-collapse: collapse;
    font-size: 0.8rem;
}

.cookie-table th {
    background: #1C4A8D;
    color: white;
    padding: 8px 12px;
    text-align: left;
}

.cookie-table td {
    padding: 8px 12px;
    border-bottom: 1px solid #e9ecef;
}

.cookie-table tr:nth-child(even) {
    background: #f8f9fa;
}

.cookie-opt-out {
    font-size: 0.85rem;
    color: #555;
    margin-top: 8px;
    padding: 8px 12px;
    background: #fff3cd;
    border-radius: 4px;
}

.cookie-opt-out a {
    color: #1C4A8D;
    font-weight: 600;
}

.browser-list {
    list-style: none;
    padding: 0;
}

.browser-list li {
    padding: 6px 0;
    font-size: 0.9rem;
    border-bottom: 1px solid #f0f0f0;
}

.browser-list li:last-child {
    border-bottom: none;
}

.browser-list a {
    color: #1C4A8D;
    font-weight: 500;
}

.cookie-warning {
    margin-top: 15px;
    padding: 15px;
    background: #fce8e6;
    border-radius: 8px;
    border-left: 4px solid #d93025;
}

.cookie-warning strong {
    color: #d93025;
}

.cookie-warning p {
    margin: 5px 0 0 0;
    font-size: 0.85rem;
}

.cookie-modal-actions {
    display: flex;
    gap: 12px;
    margin-top: 25px;
    padding-top: 20px;
    border-top: 1px solid #e9ecef;
    flex-wrap: wrap;
}

/* ========== RESPONSIVE ========== */
@media (max-width: 768px) {
    .cookie-content {
        flex-direction: column;
        align-items: stretch;
        gap: 15px;
    }
    .cookie-actions {
        justify-content: center;
    }
    .cookie-btn {
        flex: 1;
        text-align: center;
        padding: 10px 16px;
    }
    .cookie-modal-content {
        padding: 20px;
    }
    .cookie-option-header {
        flex-direction: column;
        align-items: flex-start;
    }
}
</style>